import { render, staticRenderFns } from "./PaymentInstructions.vue?vue&type=template&id=508ea3dc&scoped=true"
import script from "./PaymentInstructions.vue?vue&type=script&lang=js"
export * from "./PaymentInstructions.vue?vue&type=script&lang=js"
import style0 from "./PaymentInstructions.vue?vue&type=style&index=0&id=508ea3dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508ea3dc",
  null
  
)

export default component.exports